import { entries, type Entry } from "@/mocks/entries";
import { categories, type Category } from "@/mocks/categories";

export function getAllEntries(): Entry[] {
  return entries;
}

export function getEntryById(id: string): Entry | undefined {
  return entries.find((item) => item.id === id);
}

export function getCategoryById(id: string): Category | undefined {
  return categories.find((item) => item.id === id);
}

export function getEntriesByCategory(categoryId: string): Entry[] {
  return entries.filter((item) => item.categoryId === categoryId);
}

export function getHotEntries(limit?: number): Entry[] {
  const sorted = [...entries].sort((a, b) => b.hot - a.hot);
  return typeof limit === "number" ? sorted.slice(0, limit) : sorted;
}

export function searchEntries(keyword: string): Entry[] {
  const key = keyword.trim().toLowerCase();
  if (!key) return [];
  return entries.filter((item) => {
    const pool = [item.name, item.alias, item.title, item.summary, ...item.tags]
      .join(" ")
      .toLowerCase();
    return pool.includes(key);
  });
}

export function getRelatedEntries(entry: Entry, limit = 3): Entry[] {
  const explicit = entry.relatedIds
    .map((id) => getEntryById(id))
    .filter((item): item is Entry => Boolean(item));
  if (explicit.length >= limit) return explicit.slice(0, limit);
  const fallback = entries.filter(
    (item) => item.categoryId === entry.categoryId && item.id !== entry.id && !entry.relatedIds.includes(item.id),
  );
  return [...explicit, ...fallback].slice(0, limit);
}

export function formatHot(hot: number): string {
  if (hot >= 10000) return `${(hot / 10000).toFixed(1)} 万`;
  return `${hot}`;
}